/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import type {
  FixedSizeCodec,
  FixedSizeDecoder,
  FixedSizeEncoder,
} from "@solana/kit";
import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
} from "@solana/kit";

export interface OpenPositionWithMetadataBumps {
  positionBump: number;
  metadataBump: number;
}

export type OpenPositionWithMetadataBumpsArgs = OpenPositionWithMetadataBumps;

export function getOpenPositionWithMetadataBumpsEncoder(): FixedSizeEncoder<OpenPositionWithMetadataBumpsArgs> {
  return getStructEncoder([
    ["positionBump", getU8Encoder()],
    ["metadataBump", getU8Encoder()],
  ]);
}

export function getOpenPositionWithMetadataBumpsDecoder(): FixedSizeDecoder<OpenPositionWithMetadataBumps> {
  return getStructDecoder([
    ["positionBump", getU8Decoder()],
    ["metadataBump", getU8Decoder()],
  ]);
}

export function getOpenPositionWithMetadataBumpsCodec(): FixedSizeCodec<
  OpenPositionWithMetadataBumpsArgs,
  OpenPositionWithMetadataBumps
> {
  return combineCodec(
    getOpenPositionWithMetadataBumpsEncoder(),
    getOpenPositionWithMetadataBumpsDecoder(),
  );
}
